import { render, staticRenderFns } from "./ListRanking.vue?vue&type=template&id=c79517f4&scoped=true&"
import script from "./ListRanking.vue?vue&type=script&lang=js&"
export * from "./ListRanking.vue?vue&type=script&lang=js&"
import style0 from "./ListRanking.vue?vue&type=style&index=0&id=c79517f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c79517f4",
  null
  
)

export default component.exports